import { useEffect, useState } from 'react';
import { useFabricEditor } from './useFabricEditor';
import { useHandleHistory } from './useHandleHistory';
import { fabric } from 'fabric';

const TEXT_TYPES = ['i-text', 'textbox', 'text'];

export const setObjectLocked = (object: fabric.Object, locked: boolean) => {
  const isText = TEXT_TYPES.includes(object.type || '');
  if (object.type === 'i-text') {
    // @ts-ignore;
    object.set({ editable: !locked });
  }
  object.set({
    selectable: true,
    lockMovementX: locked,
    lockMovementY: locked,
    lockRotation: locked,
    // Text is only resized through its font size, locked or not.
    lockScalingX: isText || locked,
    lockScalingY: isText || locked,
  });
};

export const useHandleObjectLock = () => {
  const { canvas } = useFabricEditor();
  const { handleHistory } = useHandleHistory();

  const [isLocked, setIsLocked] = useState(false);

  useEffect(() => {
    const activeObjects = canvas?.getActiveObjects();
    setIsLocked(false);
    for (const activeObject of activeObjects || []) {
      if (activeObject.lockMovementX) setIsLocked(true);
    }
  }, [canvas?.getActiveObjects()]);

  const handleObjectLock = (transform?: fabric.Transform) => {
    const target = transform?.target;
    let isLockObject = isLocked;
    if (target) isLockObject = Boolean(target?.lockMovementX);
    const fabricCanvas = target?.canvas || canvas;
    if (!fabricCanvas) return null;
    const activeObjects = fabricCanvas?.getActiveObjects();
    for (const activeObject of activeObjects || []) {
      setObjectLocked(activeObject, !isLockObject);
      setIsLocked(!isLockObject);
    }
    fabricCanvas?.requestRenderAll();
    handleHistory(fabricCanvas);
  };

  return { handleObjectLock, isLocked };
};
